import { Pipe, PipeTransform } from '@angular/core';
import { AggregatorPipeService } from './aggregator.pipe.service';

@Pipe({
  name: 'aggregatorName',
  pure: false,
  standalone: true,
})
export class AggregatorNamePipe implements PipeTransform {
  aggregatorsCache: any = {};
  aggregatorPipeService: AggregatorPipeService;

  constructor(aggregatorPipeService: AggregatorPipeService) {
    this.aggregatorPipeService = aggregatorPipeService;

    aggregatorPipeService.getAggregators().subscribe((data) => {
      this.aggregatorsCache = data;
    });
  }

  hasName(key) {
    return this.aggregatorsCache[key] && this.aggregatorsCache[key].name;
  }

  getTransformation(value) {
    return this.hasName(value) ? this.aggregatorsCache[value].name : value;
  }

  getTransformations(value) {
    let text = '';
    for (let i = 0; i < value.length; i++) {
      const val = this.getTransformation(value[i]);
      text = `${text}${val}`;
      if (i !== value.length - 1) {
        text = `${text}, `;
      }
    }
    return text;
  }

  transform(value: any, args?: string): string {
    if (Array.isArray(value)) {
      return this.getTransformations(value);
    } else {
      return this.getTransformation(value);
    }
  }
}
